import { connect } from 'react-redux';
import { goBack, push } from 'redux-first-history';
import InviteTenantPage from './component';
import { getIdVerificationInfo } from '@rental-manager/actions/requests';
import { saveTenantInvitationInfo } from '@rental-manager/actions/OnboardingActions';
import { closeNotification, showModalNotification } from '@common/actions/NotificationActions';
import { trackValidationError } from '@common/actions/TrackingActions';
import { DEFAULT_ERROR, TENANT_INFO_UPDATED } from '@rental-manager/constants/NotificationConstants';
import { LANDLORD_STATUS } from '@rental-manager/constants/OnboardingConstants';
import paths from '@rental-manager/pathsManifest';
import { isHighRiskOTP } from '@common/paymentsUtils/moveInCostsUtil';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state, { propertyId }) => {
  const { moveInCostsSettings, collectMoveInCosts } = state.payments.landlord.onboarding[propertyId];
  const isHighRiskOTPPresent = isHighRiskOTP(moveInCostsSettings);
  const { isHighRiskOtpApproved, selectedLease } = state.payments.landlord.property;
  return {
    landlordEmail: state.user.email,
    currentTenantEmail: state.payments.landlord.property.currentTerm.tenantEmail,
    ...state.payments.landlord.onboarding[propertyId].tenantInvitationInfo,
    isHighRiskOTPPresent,
    isHighRiskOtpApproved,
    collectMoveInCosts,
    selectedLease,
    user: state.user,
    currentProperty: state.payments.landlord.property.listingDetails,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl, propertyId, landlordStatus }) => ({
  onSubmit: (tenantInvitationInfo, editMode, isHighRiskOTPPresent, isHighRiskOtpApproved) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(saveTenantInvitationInfo({ propertyId, tenantInvitationInfo })))
      .then(() => {
        // if user from onboarding confirmation page edit
        if (editMode) {
          return dispatch(push(baseUrl + paths.onboarding.confirmationPage));
        }

        // redirection logic for next onboarding screen
        const initialVerificationComplete =
          landlordStatus !== LANDLORD_STATUS.NOT_STARTED &&
          landlordStatus !== LANDLORD_STATUS.ONBOARDING_STARTED &&
          landlordStatus !== LANDLORD_STATUS.EXTERNAL_ACCOUNT_SET;

        if (!initialVerificationComplete) {
          return dispatch(push(baseUrl + paths.onboarding.taxVerificationPage));
        }

        if (isHighRiskOTPPresent && !isHighRiskOtpApproved) {
          return dispatch(push(baseUrl + paths.onboarding.knowledgeBasedAuthenticationPage));
        }

        return dispatch(push(baseUrl + paths.onboarding.confirmationPage));
      })
      .then(() => dispatch(getIdVerificationInfo({ propertyId })))
      .then(() => editMode && dispatch(showModalNotification(TENANT_INFO_UPDATED)))
      .catch((err) => {
        logError({ error: err });
        return dispatch(showModalNotification(DEFAULT_ERROR, { subject: 'Tenant information' }));
      }),
  onBack: (tenantInvitationInfo) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(saveTenantInvitationInfo({ propertyId, tenantInvitationInfo })))
      .then(() => dispatch(goBack())),
  onCancel: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(push(baseUrl + paths.onboarding.confirmationPage))),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(push(baseUrl + paths.onboarding.exitPaymentSetup))),
  trackValidationError: (data) => dispatch(trackValidationError(data)),
});

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  onSubmit: (tenantInvitationInfo) =>
    dispatchProps.onSubmit(
      tenantInvitationInfo,
      stateProps.editMode,
      stateProps.isHighRiskOTPPresent,
      stateProps.isHighRiskOtpApproved,
    ),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(InviteTenantPage);
